import ChevronRight from '@assets/icons/chevron-right.svg';
import React from 'react';
import { ActivityIndicator } from '@/components/activity-indicator';
import { CombinedFulfillmentListOption } from './use-fulfillment-picker';
import { createStyles } from '@/contexts/theme-context';
import { List } from '@usepepper/sprout-kit-ui';
import { SCREEN_PADDING, TYPOGRAPHY } from '@/styles';
import { SelectedFulfillmentType } from '@/contexts/new-order-actions-context-types';
import { View } from 'react-native';

interface Props {
  isLoading: boolean;
  listData: CombinedFulfillmentListOption[];
  onSelect: (option: CombinedFulfillmentListOption) => void;
  savingFulfillment: SelectedFulfillmentType | null;
}

export const FulfillmentActionSheetOptionsView: React.FC<Props> = ({
  isLoading,
  listData,
  onSelect,
  savingFulfillment,
}) => {
  const [styles, theme] = useStyles();

  return (
    <List>
      {listData.map((option, index) => {
        const fulfillmentFee = option.metadata!.fulfillmentFee;
        const isSaving = savingFulfillment?.type === option.value;

        return (
          <React.Fragment key={String(option.value)}>
            {index > 0 ? (
              <List.Separator marginHorizontal={SCREEN_PADDING} />
            ) : null}
            <List.Item
              onPress={() => onSelect(option)}
              paddingHorizontal={SCREEN_PADDING}
              paddingVertical={theme.sk.spacing.spaceMedium}
              pressable
              testID={`list-item-${index}`}
            >
              <List.Item.Content>
                <List.Item.Title style={TYPOGRAPHY.listTitle}>
                  {option.title ?? ''}
                </List.Item.Title>
              </List.Item.Content>
              <List.Item.Trailing>
                <View style={styles.fulfillmentButtonRight}>
                  {isLoading || isSaving ? (
                    <ActivityIndicator />
                  ) : fulfillmentFee ? (
                    <List.Item.Value style={TYPOGRAPHY.pSemiBold}>
                      +{fulfillmentFee}
                    </List.Item.Value>
                  ) : null}
                  {option.metadata!.nextRouteKey ? (
                    <View style={styles.rightIcon}>
                      <ChevronRight fill={theme.colors.primary} height={12} />
                    </View>
                  ) : null}
                </View>
              </List.Item.Trailing>
            </List.Item>
          </React.Fragment>
        );
      })}
    </List>
  );
};

const useStyles = createStyles((theme) => ({
  fulfillmentButtonRight: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  rightIcon: {
    marginLeft: theme.sk.spacing.spaceSMedium,
  },
}));
